import type { LinkProps } from 'next/link';
import Link from 'next/link';
import type { AnchorHTMLAttributes } from 'react';

import { TrackingParams } from '@libs/analytics';

export type FBTProductLinkProps = Omit<LinkProps, 'onClick'> & AnchorHTMLAttributes<HTMLAnchorElement>;

export function FBTProductLink({ children, ...props }: Readonly<FBTProductLinkProps>) {
    function setFindingMethod() {
        window.sessionStorage.pdpFindingMethod = TrackingParams.RECOMMENDATION_REFERER;
    }

    return (
        <Link onClick={setFindingMethod} {...props}>
            {children}
        </Link>
    );
}
